import React from 'react';

import Zoom from './Zoom';
import CenterMap from './CenterMap';

/**
* -Controls-
* Controls component
**/
class Controls extends React.Component {

	render() {

		return (
			<div className="map-controls">
				<CenterMap { ...this.props } />
				<Zoom map={ this.props.map } />
			</div>
		)
	}
}

export default Controls;



// WEBPACK FOOTER //
// ./src/components/googlemaps/Controls.js